var map = {
	"./de/AMD.png": "+aRW",
	"./en/AMD.png": "TTHJ",
	"./es/AMD.png": "wZev",
	"./fr/AMD.png": "oj0C",
	"./ja/AMD.png": "u2ti",
	"./ko/AMD.png": "BVmv",
	"./pt/AMD.png": "AkdL",
	"./ru/AMD.png": "lIsO",
	"./tc/AMD.png": "/JI5",
	"./th/AMD.png": "AcoR",
	"./zh-Hant/AMD.png": "Wrdh"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6Wlz";